import api from '../api'

//data
const state = {
  status: {
    loading:false,
    loaded:false,
    error:'', // last error
    lastLoaded:''
  },
  user: {},
  token: localStorage.getItem('mw-token'), //set default value
  type: [],
  banners: []
}

//comuted store.getters.inCart
const getters = {

}

//sync methods store.commit('increment')
const mutations = {
  LOADING_USER (state, isLoading){
    state.status.loading = isLoading
  },
  SET_LOADED_USER (state, loaded){
    state.status.loaded = loaded
  },
  SET_USER_ERROR (state, error){
    state.status.error = error
  },
  SET_USER_TOKEN (state, token) {
    localStorage.setItem('mw-token', token);
	//document.cookie = 'token=' + token + '; domain=.bioveikals.com; path=/; Secure';
    state.token = token
  },
  DEL_USER_TOKEN (state) {
    localStorage.removeItem('mw-token');
    state.token = ''
  },
  SET_USER (state, userData){
    state.user = userData
  },
  SET_USER_TYPE (state, type){
    state.type = type
  },
  SET_BANNERS (state, bannerData){
    state.banners = bannerData
  },
}

//async methods  store.dispatch('increment')
const actions = {

  logoutUser({state, commit}){


    return  api.delete('authenticate/logout')
        .then(function (response) {
          commit('DEL_USER_TOKEN'); //remove token data
          commit('SET_USER', {}); //set to empty object
          return Promise.resolve(response);

        })
        .catch(function (error) {

          commit('SET_USER_ERROR', error.response.data.error);
          commit('LOADING_USER', false);
          commit('DEL_USER_TOKEN', false);
          return Promise.reject(error);
        });


  },

  loginUser ({state, commit},credentials){

    commit('LOADING_USER', true);
    commit('SET_USER_ERROR', ''); //clear error

    return  api.post('authenticate', credentials)
        .then(function (response) {
          commit('SET_USER_TOKEN', response.data.token)
          commit('LOADING_USER', false);
          return Promise.resolve(response);

        })
        .catch(function (error) {

          commit('SET_USER_ERROR', error.response.data.error);
          commit('LOADING_USER', false);
          commit('DEL_USER_TOKEN', false);
          return Promise.reject(error);
        });

  },

  loadUser ({state, commit}) {

    commit('LOADING_USER', true);

    return api.get('authenticate/user')
      .then(function (response) {
        commit('SET_USER', response.data.user);
        commit('SET_BANNERS', response.data.banners);
        commit('LOADING_USER', false);
        commit('SET_LOADED_USER', true);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_USER', false);
        commit('SET_LOADED_USER', true); //response is not important, important is fact that store is loaded
        return Promise.reject(error);
      });
  },

  loadPersonType ({state, commit}) {

    commit('LOADING_USER', true);

    return api.get('persontype')
      .then(function (response) {
        commit('SET_USER_TYPE', response.data.data)
        commit('LOADING_USER', false);
        return Promise.resolve(response);
      })
      .catch(function (error) {
        commit('LOADING_USER', false);
        return Promise.reject(error);
      });
  },


  createGuestToken ({state, commit}) {

    commit('LOADING_USER', true);

    return api.post('authenticate/guest')
    .then(function (response) {
      commit('SET_USER_TOKEN', response.data.token);
	  commit('SET_BANNERS', response.data.banners);
      commit('LOADING_USER', false);
      return Promise.resolve(response);
    })
    .catch(function (error) {
      console.log(error)
      console.log(error.response) //for investigation
      commit('SET_USER_ERROR', error.response.data.error);
      commit('LOADING_USER', false);
      commit('DEL_USER_TOKEN', false);
      return Promise.reject(error);
    });
  },

  updateUser ({state, commit},user) {

    commit('LOADING_USER', true);

    return api.post('user/' + user.id, user)
    .then(function (response) {
      commit('SET_USER', response.data.user)
      commit('LOADING_USER', false);

      return Promise.resolve(response);

    })
    .catch(function (error) {

      commit('SET_USER_ERROR', error.response.data.error);
      commit('LOADING_USER', false);

      return Promise.reject(error);
    });
  },

  updateUserPassword ({state, commit},[user,credentials]) {

    //commit('LOADING_USER', true); disabled not to mess with password change button and loader when user data are loaded

    return api.post('user/' + user.id + '/password', credentials)
    .then(function (response) {
      //commit('LOADING_USER', false);

      return Promise.resolve(response);

    })
    .catch(function (error) {

      commit('SET_USER_ERROR', error.response.data.error);
      //commit('LOADING_USER', false);

      return Promise.reject(error);
    });
  },

  requestPasswordReset ({state, commit},credentials) {

    //commit('LOADING_USER', true); disabled not to mess with password change button and loader when user data are loaded

    return api.post('password/email', credentials)
    .then(function (response) {
      //commit('LOADING_USER', false);

      return Promise.resolve(response);

    })
    .catch(function (error) {

      commit('SET_USER_ERROR', error.response.data.error);
      //commit('LOADING_USER', false);

      return Promise.reject(error);
    });
  },



  resetPassword ({state, commit},data) {

    //commit('LOADING_USER', true); disabled not to mess with password change button and loader when user data are loaded

    return api.post('password/reset', data)
    .then(function (response) {
      //commit('LOADING_USER', false);

      return Promise.resolve(response);

    })
    .catch(function (error) {

      commit('SET_USER_ERROR', error.response.data.error);
      //commit('LOADING_USER', false);

      return Promise.reject(error);
    });
  },




}


export default {
  state, mutations, actions, getters
}



// WEBPACK FOOTER //
// ./src/store/modules/UserStore.js